import React from 'react';
import './AspectRatioSelector.css';

const aspectRatios = [
  { id: "1:1", label: "Square", width: 1, height: 1 },
  { id: "16:9", label: "Landscape", width: 16, height: 9 },
  { id: "9:16", label: "Portrait", width: 9, height: 16 },
];

const AspectRatioSelector = ({ selectedRatio, setSelectedRatio }) => {
  return (
    <div className="ratio-selector">
      {aspectRatios.map((ratio) => (
        <button
          key={ratio.id}
          className={`ratio-button ${selectedRatio === ratio.id ? 'active' : ''}`}
          onClick={() => setSelectedRatio(ratio.id)}
        >
          <div 
            className="ratio-icon"
            data-ratio={ratio.id}
          />
          <span className="ratio-label">{ratio.label}</span>
        </button>
      ))}
    </div>
  );
};

export default AspectRatioSelector; 